import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);
Vue.config.devtools = process.env.NODE_ENV === 'development';

export default new Vuex.Store({
  state: {
    token: localStorage.getItem('user-token') || '',
    status: ''
  },
  getters: {
    isAuthenticated: state => !!state.token,
    authStatus: state => state.status
  },
  mutations: {
    authRequest(state)  {
      state.status = 'loading';
    },
    authSuccess(state, token) {
      state.status = 'success';
      state.token = token;
    },
    authError(state, err) {
      state.status = 'error';
      console.log(err);
    },
    authLogout(state) {
      state.status = 'logged out',
      state.token = ''
    }
  },
  actions: {
    authRequest({commit}, user) {
      return new Promise((resolve, reject) => {
        commit('authRequest');
        axios({url: process.env.VUE_APP_BACKEND_HOST+"/oauth/token", data: user, method: 'POST'})
          .then(resp => {
            const token = resp.data.token_type + " " + resp.data.access_token;
            localStorage.setItem('user-token', token);
            axios.defaults.headers.common['Authorization'] = token;
            commit('authSuccess', token);
            resolve(resp);
          })
          .catch(err => {
            commit('authError', err);
            localStorage.removeItem('user-token');
            reject(err);
          });
      });
    },
    authLogout({commit}) {
      return new Promise((resolve) => {
        commit('authLogout');
        localStorage.removeItem('user-token');
        delete axios.defaults.headers.common['Authorization'];
        resolve();
      });
    }
  }
});
